/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Buy_BtnInputs */

const en_domain_manager_buy_btn = /** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Domain`)
};

const es_domain_manager_buy_btn = /** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar Dominio`)
};

const fr_domain_manager_buy_btn = /** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter un domaine`)
};

const de_domain_manager_buy_btn = /** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain kaufen`)
};

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const ja_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const zh_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const ar_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const id_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const it_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const ru_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const pt_domain_manager_buy_btn = en_domain_manager_buy_btn;

/** @type {(inputs: Domain_Manager_Buy_BtnInputs) => LocalizedString} */
const ko_domain_manager_buy_btn = en_domain_manager_buy_btn;

/**
* | output |
* | --- |
* | "Buy Domain" |
*
* @param {Domain_Manager_Buy_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_buy_btn = /** @type {((inputs?: Domain_Manager_Buy_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Buy_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_buy_btn(inputs)
	if (locale === "es") return es_domain_manager_buy_btn(inputs)
	if (locale === "fr") return fr_domain_manager_buy_btn(inputs)
	if (locale === "de") return de_domain_manager_buy_btn(inputs)
	if (locale === "ja") return ja_domain_manager_buy_btn(inputs)
	if (locale === "zh") return zh_domain_manager_buy_btn(inputs)
	if (locale === "ar") return ar_domain_manager_buy_btn(inputs)
	if (locale === "id") return id_domain_manager_buy_btn(inputs)
	if (locale === "it") return it_domain_manager_buy_btn(inputs)
	if (locale === "ru") return ru_domain_manager_buy_btn(inputs)
	if (locale === "pt") return pt_domain_manager_buy_btn(inputs)
	return ko_domain_manager_buy_btn(inputs)
});